import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { BlockUI } from 'primeng/blockui';
import { ProgressSpinner } from 'primeng/progressspinner';
import { LoadingOverlayService } from '@app/core/services/loading-overlay.service';

/**
 * Overlay plein écran affiché tant que `LoadingOverlayService.isLoading()`
 * est vrai, à instancier une seule fois dans le shell racine (`app.html`).
 */
@Component({
  selector: 'app-loading-overlay',
  imports: [BlockUI, ProgressSpinner],
  templateUrl: './loading-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent {
  protected readonly loadingOverlayService = inject(LoadingOverlayService);
  readonly loading = input<boolean | undefined>();
  readonly small = input(false);
  protected readonly isLoading = computed(
    () => this.loading() ?? this.loadingOverlayService.isLoading(),
  );
}
